import { SITES } from "~types/types";

const { BLOOMBERG, BLOOMBERG_CO_JP } = SITES;

export const getSiteNameForLocale = (locale: string) => {
    switch (locale) {
        case "ja":
            return BLOOMBERG_CO_JP;
        default:
            return BLOOMBERG;
    }
};
